import { FC } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm, InjectedFormProps } from 'redux-form'
import I18n from 'translations/i18n'
import { Button, Spacer, Grid } from '@jisr-hr/design-system'
import { required } from 'components/global/form/FormValidations'
import { DatePicker, Input } from 'components/global/molecules/redux-form'

type ResumptionFormProps = {
  fetching: boolean | undefined
  handleSubmit?: () => void
}

const ResumptionForm: FC<ResumptionFormProps & InjectedFormProps<any, ResumptionFormProps>> = ({
  handleSubmit,
  fetching,
}: ResumptionFormProps) => (
  <form onSubmit={handleSubmit}>
    <Grid
      container
      direction="column"
      spacing={2}
    >
      <Grid
        item
        md={12}
      >
        <Field
          name="return_date"
          component={DatePicker}
          label="return_date"
          validate={[required]}
        />
      </Grid>
      <Spacer height="18px" />
      <Grid
        item
        md={12}
      >
        <Field
          as="textarea"
          name="reason"
          component={Input}
          rows={5}
          label="reason"
        />
      </Grid>
      <Grid
        item
        md={12}
      >
        <Button
          label={I18n.t('submit')}
          disabled={fetching}
          type="submit"
          size="medium"
          onSubmit={handleSubmit}
        />
      </Grid>
    </Grid>
  </form>
)

ResumptionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
}

export default reduxForm<any, ResumptionFormProps>({
  form: 'ResumptionForm',
  enableReinitialize: true,
})(ResumptionForm)
